const UTILS = {
 ConvertStringToJS(str) {
 var script = document.createElement("script");
 script.text = str;
 document.head.appendChild(script).parentNode.removeChild(script);
 },

 FormatMoney(value) {
 let price = new Intl.NumberFormat("en-US", {
 style: "currency",
 currency: "USD",
 });
 return price.format(value / 100).replace(".00", "");
 },

 async AddItemsToCart(items_to_add) {
 // items_to_add = [{
 // quantity: qty,
 // id: variant_id,
 // selling_plan: selling_plan_id,
 // properties: {}
 // }]
 return await fetch("/cart/add.js", {
 method: "POST",
 headers: {
 "Content-Type": "application/json",
 },
 body: JSON.stringify({ items: items_to_add }),
 });
 },

 async RefreshCart() {
 let $drawer =
 document.querySelector("cart-notification") ||
 document.querySelector("cart-drawer");
 let sections = $drawer
 .getSectionsToRender()
 .map((item) => item.id)
 .join(",");
 let cart = await fetch("/cart.js").then((res) => res.json());
 let line_item_response = cart.items[0];

 if (!line_item_response) return;

 let sections_response = await fetch(`/?sections=${sections}`).then(
 (response) => response.json(),
 );
 line_item_response.sections = sections_response;
 $drawer.renderContents(line_item_response);
 $drawer.classList.remove("is-empty");
 },

 /*
 async RefreshCart() {
 try {
 const $drawer =
 document.querySelector("cart-notification") ||
 document.querySelector("cart-drawer");

 // Ensure the cart drawer exists before proceeding
 if (!$drawer) {
 console.error("Cart drawer not found.");
 return;
 }

 // Get sections to update (cart drawer and cart icon bubble)
 const sections = $drawer
 .getSectionsToRender()
 .map((item) => item.id)
 .join(",");

 // Fetch the current cart data
 const cart = await fetch("/cart.js").then((res) => res.json());

 if (!cart || cart.items.length === 0) {
 console.warn("Cart is empty.");
 $drawer.classList.add("is-empty");
 return;
 }

 // Fetch updated sections (using Shopify's sections API)
 const response = await fetch(
 `/?sections=${sections}&sections_url=${window.location.pathname}`
 ).then((res) => res.json());

 if (!response) {
 console.error("Failed to fetch updated sections.");
 return;
 }

 // Render the cart drawer with the updated sections
 $drawer.renderContents({
 id: cart.items[0].id,
 sections: response,
 });

 $drawer.classList.remove("is-empty");
 } catch (error) {
 console.error("Error refreshing the cart:", error);
 }
 },

 ensureCartDrawerInitialized() {
 // Check if the cart drawer exists and initialize it if necessary
 let $drawer = document.querySelector("cart-drawer");
 if (!$drawer) {
 console.error("Cart drawer is not initialized.");
 return false; // Prevent further actions if the drawer is not initialized
 }
 return true;
 },
 */
};

document.addEventListener("rebuy.add", (e) => {
 //UTILS.RefreshCart();
});

const MOBILE_ACCORDION_SELECTOR = "[data-mobile-accordion]";
const MOBILE_ACCORDION_TRIGGER = "[data-accordion-trigger]";
const MOBILE_ACCORDION_PANEL = "[data-accordion-panel]";
const reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

const escapeAccordionId = (value) => {
 if (!value) return value;
 if (window.CSS && typeof window.CSS.escape === "function") {
 return window.CSS.escape(value);
 }
 return value.replace(/[^a-zA-Z0-9_-]/g, "\\$&");
};

const expandMobileAccordion = (trigger, panel) => {
 const item = trigger.closest("[data-accordion-item]");
 trigger.setAttribute("aria-expanded", "true");
 trigger.classList.add("is-open");
 if (item) item.classList.add("is-open");
 panel.hidden = false;
 panel.classList.add("is-open");

 if (reduceMotionQuery.matches) {
 panel.style.height = "auto";
 return;
 }

 panel.style.height = "0px";
 panel.getBoundingClientRect();

 const targetHeight = panel.scrollHeight;
 panel.style.height = `${targetHeight}px`;

 const handleTransitionEnd = (event) => {
 if (event.target !== panel) return;
 panel.style.height = "auto";
 panel.removeEventListener("transitionend", handleTransitionEnd);
 };

 panel.addEventListener("transitionend", handleTransitionEnd);
};

const collapseMobileAccordion = (trigger, panel) => {
 const item = trigger.closest("[data-accordion-item]");
 trigger.setAttribute("aria-expanded", "false");
 trigger.classList.remove("is-open");
 if (item) item.classList.remove("is-open");

 if (reduceMotionQuery.matches) {
 panel.classList.remove("is-open");
 panel.style.height = "";
 panel.hidden = true;
 return;
 }

 const startingHeight = panel.scrollHeight;
 panel.style.height = `${startingHeight}px`;
 panel.getBoundingClientRect();
 panel.style.height = "0px";

 const handleTransitionEnd = (event) => {
 if (event.target !== panel) return;
 panel.classList.remove("is-open");
 panel.style.height = "";
 panel.hidden = true;
 panel.removeEventListener("transitionend", handleTransitionEnd);
 };

 panel.addEventListener("transitionend", handleTransitionEnd);
};

const toggleMobileAccordion = (trigger, panel) => {
 const isOpen = trigger.getAttribute("aria-expanded") === "true";
 if (isOpen) {
 collapseMobileAccordion(trigger, panel);
 } else {
 expandMobileAccordion(trigger, panel);
 }
};

const bindMobileAccordion = (accordion) => {
 accordion.querySelectorAll(MOBILE_ACCORDION_TRIGGER).forEach((trigger) => {
 if (trigger.dataset.mobileAccordionBound === "true") return;

 const panelId = trigger.getAttribute("aria-controls");
 if (!panelId) return;

 const selector = `#${escapeAccordionId(panelId)}`;
 const panel = accordion.querySelector(selector);
 if (!panel || !panel.matches(MOBILE_ACCORDION_PANEL)) return;

 trigger.dataset.mobileAccordionBound = "true";

 if (trigger.getAttribute("aria-expanded") !== "true") {
 panel.hidden = true;
 panel.classList.remove("is-open");
 panel.style.height = "";
 } else {
 trigger.classList.add("is-open");
 const item = trigger.closest("[data-accordion-item]");
 if (item) item.classList.add("is-open");
 panel.hidden = false;
 panel.classList.add("is-open");
 panel.style.height = "auto";
 }

 trigger.addEventListener("click", () =>
 toggleMobileAccordion(trigger, panel),
 );
 });
};

const initMobileMenuAccordions = (scope = document) => {
 if (!scope) return;
 scope.querySelectorAll(MOBILE_ACCORDION_SELECTOR).forEach((accordion) => {
 if (accordion.dataset.mobileAccordionInitialized !== "true") {
 accordion.dataset.mobileAccordionInitialized = "true";
 }
 bindMobileAccordion(accordion);
 });
};

document.addEventListener("DOMContentLoaded", () => {
 initMobileMenuAccordions();
});

document.addEventListener("shopify:section:load", (event) => {
 initMobileMenuAccordions(event.target);
});

document.addEventListener("shopify:section:select", (event) => {
 initMobileMenuAccordions(event.target);
});

/*
document.addEventListener("rebuy.add", (e) => {

 if (UTILS.ensureCartDrawerInitialized()) {
 // Only refresh the cart if the cart drawer is properly initialized
 UTILS.RefreshCart();
 }
});

document.addEventListener("cart:addtocart_complete", (e) => {
 if (UTILS.ensureCartDrawerInitialized()) {
 // Handle regular add-to-cart behavior
 UTILS.RefreshCart();
 }
});
*/

document.addEventListener("alpine:init", () => {
 let products = [];

 Alpine.data("ProductQuickAdd", () => ({
 $section: null,
 $productCard: null,
 $productForm: null,
 $variantId: null,
 product: null,
 isBundle: false,
isSetBundle: false,
setSizePositions: [],
selectedSetSizes: {},
editingSetOptions: {},
isSetBundleReady: false,
 hideSizes: true,
 mounted() {
 let am = this;
 am.$section = am.$el;
 am.$productForm = am.$section.querySelector("product-form form");
 am.$variantId = am.$productForm.querySelector('[name="id"]');
 am.$productCard = am.$section.closest(".product-card-wrapper");

 am.SetProduct();

 document.addEventListener(
 "cart:addtocart_complete",
 am.OnAddToCartComplete.bind(am),
 );

if (am.isSetBundle) {
  am.initializeSetState();
}
 },
 SetProduct() {
 let am = this;
 UTILS.ConvertStringToJS(
 am.$section.querySelector("[data-product-json]").innerHTML,
 );
const normalize = (value) => (value || "").trim().toLowerCase();
const options = product.options_with_values || [];
product.color_option = options.find((option) => {
  const name = normalize(option.name);
  return name === "color" || name === "colour";
});
product.size_option = options.find((option) => normalize(option.name) === "size");
product.set_size_options = options.filter((option) =>
  normalize(option.name).includes("size"),
);
 am.product = product;
const bundleFromDom = am.$section?.dataset?.isBundle === "true";
am.isBundle = bundleFromDom || Boolean(am.product?.tags?.includes("Bundle"));
am.isSetBundle =
  am.isBundle &&
  Boolean(am.product?.tags?.includes("Set")) &&
  am.product.set_size_options.length >= 2;
am.setSizePositions = am.isSetBundle
  ? am.product.set_size_options.slice(0, 2).map((option) => option.position)
  : [];
 products.push(product);
 },
 ToggleSizes(toggle) {
 let am = this;
 am.hideSizes = !toggle;
 if (toggle) {
 am.$section.querySelectorAll(".x-cloak-hidden").forEach((item) => {
 item.classList.remove("x-cloak-hidden");
 });
 }
 },
isVariantAvailable(variant) {
if (!variant) return false;
if (variant.inventory_management !== "shopify" || variant.inventory_policy === "continue") {
  return Boolean(variant.available);
}
if (this.isBundle) {
  return Boolean(variant.available);
}
const suffix = window.currentInventorySuffix || "usa-inventory";
const inventoryKey = `${variant.id}-${suffix}`;
const locationInventory = window.locationInventoryData?.[inventoryKey] ?? 0;
return locationInventory > 0;
},
 GetSelectedVariant() {
 let am = this;
let baseVariant = am.product?.selected_variant || am.product?.variants?.[0] || null;
if (!baseVariant) return null;

let selectedOptions = Array.isArray(baseVariant.options)
  ? [...baseVariant.options]
  : [];
let checkedInputs = [...am.$section.querySelectorAll("input:checked")];
checkedInputs.forEach((input) => {
  const position = Number(input.dataset.optionPosition || 0);
  if (!position) return;
  selectedOptions[position - 1] = input.value;
});

let variant = am.product.variants.find((item) => {
  return Array.isArray(item.options) && item.options.join("/") === selectedOptions.join("/");
});
return variant || null;
},
initializeSetState() {
let am = this;
am.selectedSetSizes = {};
am.editingSetOptions = {};
am.setSizePositions.forEach((position) => {
  am.editingSetOptions[position] = false;
});
am.$section.querySelectorAll("[data-set-option-input]").forEach(($input) => {
  $input.checked = false;
});
am.updateSetAvailability();
am.updateSetBundleReady();
},
isSetOptionSelected(position) {
let am = this;
return Boolean(am.selectedSetSizes[position]);
},
getSetSelectedLabel(position) {
let am = this;
return am.selectedSetSizes[position] || "";
},
isSetValueSelected(position, value) {
let am = this;
return am.selectedSetSizes[position] === value;
},
isSetOptionCollapsed(position) {
let am = this;
if (!am.isSetOptionSelected(position)) return false;
return !am.editingSetOptions[position];
},
e_EditSetOption(position) {
let am = this;
am.editingSetOptions[position] = true;
am.updateSetAvailability();
},
e_SelectSetOption(e) {
let am = this;
let target = e.currentTarget;
let position = Number(target.dataset.optionPosition || 0);
if (!position) return;
am.selectedSetSizes[position] = target.value;
am.editingSetOptions[position] = false;
am.updateSetAvailability();
am.updateSetBundleReady();
},
updateSetBundleReady() {
let am = this;
if (!am.isSetBundle) {
  am.isSetBundleReady = true;
  return;
}
let hasBoth = am.setSizePositions.every((position) => Boolean(am.selectedSetSizes[position]));
if (!hasBoth) {
  am.isSetBundleReady = false;
  return;
}
const variant = am.GetSelectedVariant();
am.isSetBundleReady = Boolean(variant && am.isVariantAvailable(variant));
},
getSetAddButtonText() {
let am = this;
if (!am.isSetBundle) return window.variantStrings?.addToCart || "Add to cart";
if (!am.isSetBundleReady) {
  return window.variantStrings?.selectBothSizes || "Select both sizes";
}
return window.variantStrings?.addToCart || "Add to cart";
},
updateSetAvailability() {
let am = this;
if (!am.isSetBundle) return;
am.$section.querySelectorAll("[data-set-option-input]").forEach(($input) => {
  const position = Number($input.dataset.optionPosition || 0);
  const value = $input.value;
  const otherPosition = am.setSizePositions.find((item) => item !== position);
  const optionId = `option${position}`;
  const otherOptionId = `option${otherPosition}`;
  let matchingVariants = am.product.variants.filter((variant) => variant[optionId] === value);
  if (am.selectedSetSizes[otherPosition]) {
    matchingVariants = matchingVariants.filter((variant) => {
      return variant[otherOptionId] === am.selectedSetSizes[otherPosition];
    });
  }
  const isAvailable = matchingVariants.some((variant) => am.isVariantAvailable(variant));
  $input.disabled = !isAvailable;
  if ($input.disabled && $input.checked) {
    $input.checked = false;
    delete am.selectedSetSizes[position];
    am.editingSetOptions[position] = true;
  }
});
am.updateSetBundleReady();
 },
 OnAddToCartComplete() {
 let am = this;
 am.ToggleSizes(false);
 },
 CheckPreorder(variant) {
 let am = this;
 let $preorderAttr = am.$productForm.querySelector(
 "#preorder_consolidated",
 );
if (!$preorderAttr) return;
if (!variant || !variant.mf) {
  $preorderAttr.setAttribute("name", "");
  $preorderAttr.value = "";
  return;
}
 if (variant.mf.consolidated_pre_order_control) {
 $preorderAttr.setAttribute("name", "properties[Pre-order]");
 $preorderAttr.value = variant.mf.consolidated_pre_order_date_range;
 } else {
 $preorderAttr.setAttribute("name", "");
  $preorderAttr.value = "";
 }
 },
CheckFinalSale(variant) {
    let am = this;
    if (!variant) return;
    let $finalSaleAttr = am.$productForm.querySelector(
    `#final_sale_quickadd_${variant.product_id}`,
    );
    if (!$finalSaleAttr) return;
    if (window.themeSettings?.enableFinalSale !== true) {
    $finalSaleAttr.setAttribute("name", "");
    $finalSaleAttr.value = "";
    return;
    }
    if (am.product.tags && am.product.tags.includes("fs-exclusion")) {
    $finalSaleAttr.setAttribute("name", "");
    $finalSaleAttr.value = "";
    return;
    }
    if (variant.compare_price > variant.price) {
    $finalSaleAttr.setAttribute("name", "properties[Sale]");
    $finalSaleAttr.value = window.globalStrings?.finalSale || "Final Sale";
    } else {
    $finalSaleAttr.setAttribute("name", "");
    }
},
 e_ToggleSizes(e, toggle) {
 let am = this;
 if (
   !am.isSetBundle &&
   (am.product.variants.length == 1 ||
     (am.product.color_option && !am.product.size_option))
 ) {
 am.e_QuickAddToCart(e);
 return;
 }

 am.ToggleSizes(toggle);
 },
 e_QuickAddToCart(e) {
 let am = this;
if (am.isSetBundle && !am.isSetBundleReady) {
  return;
}
 am.$nextTick(() => {
   let variant = am.GetSelectedVariant();
   if (!variant) {
     console.warn("No variant selected");
     return;
   }
   am.CheckPreorder(variant);
   am.CheckFinalSale(variant);
   if (!am.$variantId) return;
   am.$variantId.value = variant.id;
   if (!am.$productForm) return;
   am.$productForm.dispatchEvent(new Event("submit", { bubbles: true }));
 });
 },
 e_ShowColorImage() {
 let am = this;
 let variant = am.GetSelectedVariant();

 if (!variant.media) return;

 let $productCard = am.$section.closest(".product-card-wrapper");
 if (!$productCard) return;

 let $image = $productCard.querySelector(".card__media img:last-of-type");
 if (!$image) return;

 $image.setAttribute("src", variant.media.src);
 $image.setAttribute("srcset", `${variant.media.src}?width=533`);
 },
 e_UpdateAvailableSizes(e) {
  let am = this;
if (am.isSetBundle) return;
 if (!am.product.size_option) return;
 if (!am.product.color_option) return;

 const colorOpt = am.product.color_option;
 const sizeOpt = am.product.size_option;
 const sameOption =
   Boolean(colorOpt && sizeOpt && colorOpt.position === sizeOpt.position);

 let target = e.currentTarget;
 let color = target?.value;
 let size_option_id = `option${sizeOpt.position}`;

 let matching_variants = am.product.variants;
 if (!sameOption && colorOpt && color != null && color !== undefined && color !== "") {
   let color_option_id = `option${colorOpt.position}`;
   matching_variants = am.product.variants.filter((v) => v[color_option_id] === color);
 }

 am.product.size_option.values.forEach((size) => {
 let size_variant = matching_variants.find(
 (v) => v[size_option_id] == size,
 );
 am.$productCard
 .querySelectorAll(`.size-swatches input[value="${size}"]`)
 .forEach(($size) => {
 if (!size_variant) {
   $size.disabled = true;
   return;
 }
 if (am.isBundle) {
   $size.disabled = !((size_variant.inventory?.quantity ?? 0) > 0);
 } else {
   $size.disabled = !size_variant.available;
 }
 });
 });
 },
 }));

 Alpine.data("QuickAddDesktop", () => ({
 $section: null,
 $productCard: null,
 $productForm: null,
product: null,
isBundle: false,
isSetBundle: false,
setSizePositions: [],
selectedSetSizes: {},
editingSetOptions: {},
isSetBundleReady: false,
 hideSizes: true,
 mounted() {
 let am = this;
 am.$section = this.$el;
 am.$productCard = am.$section.closest(".product-card-wrapper");
 am.$productForm = am.$productCard.querySelector("product-form form");

 am.SetProduct();

 am.$section
 .querySelectorAll(".x-cloak-hidden")
 .forEach((item) => item.classList.remove("x-cloak-hidden"));

 document.addEventListener(
 "cart:addtocart_complete",
 am.OnAddToCartComplete.bind(am),
 );
if (am.isSetBundle) {
  am.initializeSetState();
}
 },
 SetProduct() {
 let am = this;
 UTILS.ConvertStringToJS(
 am.$productCard.querySelector("[data-product-json]").innerHTML,
 );
const normalize = (value) => (value || "").trim().toLowerCase();
const options = product.options_with_values || [];
product.color_option = options.find((option) => {
  const name = normalize(option.name);
  return name === "color" || name === "colour";
});
product.size_option = options.find((option) => normalize(option.name) === "size");
product.set_size_options = options.filter((option) =>
  normalize(option.name).includes("size"),
);
 am.product = product;
const bundleFromDom = am.$section?.dataset?.isBundle === "true";
am.isBundle = bundleFromDom || Boolean(am.product?.tags?.includes("Bundle"));
am.isSetBundle =
  am.isBundle &&
  Boolean(am.product?.tags?.includes("Set")) &&
  am.product.set_size_options.length >= 2;
am.setSizePositions = am.isSetBundle
  ? am.product.set_size_options.slice(0, 2).map((option) => option.position)
  : [];
 },
 ToggleSizes(toggle) {
 let am = this;
 am.hideSizes = !toggle;
 },
isVariantAvailable(variant) {
if (!variant) return false;
if (variant.inventory_management !== "shopify" || variant.inventory_policy === "continue") {
  return Boolean(variant.available);
}
if (this.isBundle) {
  return Boolean(variant.available);
}
const suffix = window.currentInventorySuffix || "usa-inventory";
const inventoryKey = `${variant.id}-${suffix}`;
const locationInventory = window.locationInventoryData?.[inventoryKey] ?? 0;
return locationInventory > 0;
},
GetSelectedVariant() {
let am = this;
let baseVariant = am.product?.selected_variant || am.product?.variants?.[0] || null;
if (!baseVariant) return null;
let selectedOptions = Array.isArray(baseVariant.options) ? [...baseVariant.options] : [];
let checkedInputs = [...am.$section.querySelectorAll("input:checked")];
checkedInputs.forEach((input) => {
  const position = Number(input.dataset.optionPosition || 0);
  if (!position) return;
  selectedOptions[position - 1] = input.value;
});
let variant = am.product.variants.find((item) => {
  return Array.isArray(item.options) && item.options.join("/") === selectedOptions.join("/");
});
return variant || null;
},
initializeSetState() {
let am = this;
am.selectedSetSizes = {};
am.editingSetOptions = {};
am.setSizePositions.forEach((position) => {
  am.editingSetOptions[position] = false;
});
am.$section.querySelectorAll("[data-set-option-input]").forEach(($input) => {
  $input.checked = false;
});
am.updateSetAvailability();
am.updateSetBundleReady();
},
isSetOptionSelected(position) {
return Boolean(this.selectedSetSizes[position]);
},
getSetSelectedLabel(position) {
return this.selectedSetSizes[position] || "";
},
isSetValueSelected(position, value) {
return this.selectedSetSizes[position] === value;
},
isSetOptionCollapsed(position) {
if (!this.isSetOptionSelected(position)) return false;
return !this.editingSetOptions[position];
},
e_EditSetOption(position) {
this.editingSetOptions[position] = true;
this.updateSetAvailability();
},
e_SelectSetOption(e) {
let target = e.currentTarget;
let position = Number(target.dataset.optionPosition || 0);
if (!position) return;
this.selectedSetSizes[position] = target.value;
this.editingSetOptions[position] = false;
this.updateSetAvailability();
this.updateSetBundleReady();
},
updateSetBundleReady() {
if (!this.isSetBundle) {
  this.isSetBundleReady = true;
  return;
}
let hasBoth = this.setSizePositions.every((position) => Boolean(this.selectedSetSizes[position]));
if (!hasBoth) {
  this.isSetBundleReady = false;
  return;
}
const variant = this.GetSelectedVariant();
this.isSetBundleReady = Boolean(variant && this.isVariantAvailable(variant));
},
getSetAddButtonText() {
if (!this.isSetBundle) return window.variantStrings?.addToCart || "Add to cart";
if (!this.isSetBundleReady) {
  return window.variantStrings?.selectBothSizes || "Select both sizes";
}
return window.variantStrings?.addToCart || "Add to cart";
},
updateSetAvailability() {
if (!this.isSetBundle) return;
this.$section.querySelectorAll("[data-set-option-input]").forEach(($input) => {
  const position = Number($input.dataset.optionPosition || 0);
  const value = $input.value;
  const otherPosition = this.setSizePositions.find((item) => item !== position);
  const optionId = `option${position}`;
  const otherOptionId = `option${otherPosition}`;
  let matchingVariants = this.product.variants.filter((variant) => variant[optionId] === value);
  if (this.selectedSetSizes[otherPosition]) {
    matchingVariants = matchingVariants.filter((variant) => {
      return variant[otherOptionId] === this.selectedSetSizes[otherPosition];
    });
  }
  const isAvailable = matchingVariants.some((variant) => this.isVariantAvailable(variant));
  $input.disabled = !isAvailable;
  if ($input.disabled && $input.checked) {
    $input.checked = false;
    delete this.selectedSetSizes[position];
    this.editingSetOptions[position] = true;
  }
});
this.updateSetBundleReady();
},
syncSetSelectionsToMainForm() {
let am = this;
const $quickaddMain = am.$productCard.querySelector(".quick-add-mainform");
if (!$quickaddMain) return;
Object.entries(am.selectedSetSizes).forEach(([position, value]) => {
  const $inputs = $quickaddMain.querySelectorAll(
    `[data-set-option-input][data-option-position="${position}"]`,
  );
  $inputs.forEach(($input) => {
    const matches = $input.value === value;
    $input.checked = matches;
    if (matches) {
      $input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
});
},
 OnAddToCartComplete() {
 let am = this;
 am.ToggleSizes(false);
 },
 e_ToggleSizes(e, toggle) {
 let am = this;

 if (
 !am.isSetBundle &&
 (am.product.variants.length == 1 ||
   (am.product.color_option && !am.product.size_option))
 ) {
 am.$productForm.dispatchEvent(new Event("submit"));
 return;
 }
 am.ToggleSizes(toggle);
 },
 e_QuickAddToCart(size) {
 let am = this;
if (am.isSetBundle) {
  if (!am.isSetBundleReady) return;
  const variant = am.GetSelectedVariant();
  if (!variant) return;
  const $form = am.$productCard.querySelector("product-form form");
  const $variantId = $form?.querySelector('[name="id"]');
  if (!$form || !$variantId) return;
  am.syncSetSelectionsToMainForm();
  $variantId.value = variant.id;
  const $preorderAttr = $form.querySelector("#preorder_consolidated");
  if ($preorderAttr) {
    if (!variant.mf) {
      $preorderAttr.setAttribute("name", "");
      $preorderAttr.value = "";
    } else if (variant.mf.consolidated_pre_order_control) {
      $preorderAttr.setAttribute("name", "properties[Pre-order]");
      $preorderAttr.value = variant.mf.consolidated_pre_order_date_range;
    } else {
      $preorderAttr.setAttribute("name", "");
      $preorderAttr.value = "";
    }
  }
  const $finalSaleAttr = $form.querySelector(`#final_sale_quickadd_${variant.product_id}`);
  if ($finalSaleAttr) {
    if (window.themeSettings?.enableFinalSale !== true) {
      $finalSaleAttr.setAttribute("name", "");
      $finalSaleAttr.value = "";
    } else if (am.product.tags && am.product.tags.includes("fs-exclusion")) {
      $finalSaleAttr.setAttribute("name", "");
      $finalSaleAttr.value = "";
    } else if (variant.compare_price > variant.price) {
      $finalSaleAttr.setAttribute("name", "properties[Sale]");
      $finalSaleAttr.value = window.globalStrings?.finalSale || "Final Sale";
    } else {
      $finalSaleAttr.setAttribute("name", "");
    }
  }
  am.$nextTick(() => {
    $form.dispatchEvent(new Event("submit", { bubbles: true }));
  });
  return;
}
 let $quickadd_main = am.$productCard.querySelector(".quick-add-mainform");
 let $size = $quickadd_main?.querySelector(
 `.size-swatches input[value="${size}"]`,
 );
 if (!$size) return;
 $size.checked = true;
 $size.dispatchEvent(new Event("change", { bubbles: true }));

 let $sizeLabel = $quickadd_main.querySelector(
 `.size-swatches label[data-size="${size}"]`,
 );
 $sizeLabel.dispatchEvent(new Event("click", { bubbles: true }));
 },
 }));

 Alpine.data("BundleBuilder", () => ({
 $section: null,
 $product_cards: [],
 bundle_items: [],
 variants_to_add: [],
 price_total: 0,
 price_bundle: 0,
 selected_size: null,
 max_count: 7,
 mounted() {
 let am = this;
 am.$section = am.$el;
 am.$section.style.setProperty(
 "--header-height",
 `${document.querySelector(".header-wrapper").clientHeight}px`,
 );
 am.$product_cards = am.$section.querySelectorAll(".product-card");
 am.$section.removeAttribute("x-cloak");

 /*
 am.$product_cards.forEach(($product) => {
 $product
 .querySelector(".color-swatches")
 .addEventListener("change", (e) => {
 am.UpdateAvailableColors();
 });
 });
*/
 am.$watch("bundle_items", am.UpdateBundlePrice.bind(am));

 /*
 am.$watch("bundle_items", () => {
 let variants_to_add = [];
 am.bundle_items.forEach((bundle_item) => {
 let existing_item = variants_to_add.find(
 (item) => item.id == bundle_item.id
 );
 let quantity = !existing_item ? 1 : existing_item.quantity + 1;

 if (!existing_item) {
 variants_to_add.push({
 id: bundle_item.id,
 quantity: quantity,
 properties: {
 "Pre-order": bundle_item.mf.consolidated_pre_order_control
 ? "Yes"
 : "No",
 "Pre-order Date":
 bundle_item.mf.consolidated_pre_order_date_range || "",
 },
 });
 } else {
 existing_item.quantity = quantity;
 }
 });
 am.variants_to_add = variants_to_add;
 });
 */
 am.$watch("bundle_items", () => {
 let variants_to_add = [];
 am.bundle_items.forEach((bundle_item) => {
 let existing_item = variants_to_add.find(
 (item) => item.id === bundle_item.id,
 );
 let quantity = !existing_item ? 1 : existing_item.quantity + 1;

 let variantData = {
 id: bundle_item.id,
 quantity: quantity,
 properties: {},
 };

 // Add preorder properties if applicable
 if (bundle_item.mf.consolidated_pre_order_control) {
 variantData.properties = {
 [window.globalStrings?.preorderTitle || "Pre-order"]:
 bundle_item.mf.consolidated_pre_order_date_range || "",
 };
 }

 // Add to variants_to_add array
 if (!existing_item) {
 variants_to_add.push(variantData);
 } else {
 existing_item.quantity = quantity;
 }
 });
 am.variants_to_add = variants_to_add;
 });
 },
 e_SelectSize(e) {
 let am = this;
 am.selected_size = e.target.value;
 am.UpdateAvailableColors();
 },

 e_AddToBundle(e) {
 let am = this;
 if (e.target.classList.contains("disabled")) return;
 let $product = e.target.closest(".product-card");
 let product_id = $product.dataset.product_id;
 let product = products.find((p) => p.id == product_id);
 let color = $product.querySelector(".color-swatches input:checked").value;
 let values = [color, am.selected_size];
 let variant = product.variants.find((v) => {
 return v.options.join("/") === values.join("/");
 });
 if (am.bundle_items.length == am.max_count) return;
 am.bundle_items.push(variant);
 },

 e_RemoveItem(e, index) {
 let am = this;
 am.bundle_items.splice(index, 1);
 },
 e_ToggleSelectionItems(e) {
 let am = this;
 am.$section
 .querySelector(".selected-items-wrap")
 .classList.toggle("active");
 },
 async e_AddRemainingBundleItems(e) {
 let am = this;
 let $form = e.target.closest("form");
 if (am.variants_to_add.length == 1) {
 $form.dispatchEvent(new Event("submit", { bubbles: true }));
 return;
 }

 let remaining_items = [...am.variants_to_add].splice(
 (am.variants_to_add.length - 1) * -1,
 );
 UTILS.AddItemsToCart(remaining_items).then((res_atc) => {
 $form.dispatchEvent(new Event("submit", { bubbles: true }));
 });
 },
 isVariantAvailable(variant) {
 // Check if variant is available based on location inventory
 if (
 variant.inventory_management !== "shopify" ||
 variant.inventory_policy === "continue"
 ) {
 return variant.available;
 }

 // Get location inventory
 const suffix = window.currentInventorySuffix || "usa-inventory";
 const inventoryKey = `${variant.id}-${suffix}`;
 const locationInventory =
 window.locationInventoryData?.[inventoryKey] || 0;

 return locationInventory > 0;
 },

 UpdateAvailableColors() {
 let am = this;
 am.$product_cards.forEach(($product) => {
 let product_id = $product.dataset.product_id;
 let product = products.find((p) => p.id == product_id);
 if (!product.color_option) return;
 product.color_option.values.forEach((color) => {
 let values = [color, am.selected_size];
 let variant = product.variants.find((v) => {
 return v.options.join("/") === values.join("/");
 });
 if (!variant) return;
 let $color = $product.querySelector(`input[value="${color}"]`);
 $color.disabled = !am.isVariantAvailable(variant);

 if ($color.checked) {
 $product
 .querySelector(".btn-add-item")
 .classList.toggle("disabled", !am.isVariantAvailable(variant));
 }
 });
 });
 },
 UpdateBundlePrice() {
 let am = this;
 am.price_total = am.bundle_items.reduce(
 (sum, variant) => sum + variant.price,
 0,
 );
 if (am.bundle_items.length == 2) {
 am.price_bundle = am.price_total * 0.95;
 } else if (am.bundle_items.length > 2 && am.bundle_items.length <= 5) {
 am.price_bundle = am.price_total * 0.9;
 } else if (am.bundle_items.length > 5) {
 am.price_bundle = am.price_total * 0.85;
 } else {
 am.price_bundle = am.price_total;
 }
 },
 }));

 Alpine.data("VariantCollection", () => ({
 $section: null,
 $product_cards: [],
 bundle_items: [],
 variants_to_add: [],
 selected_size: null,
 max_count: 7,
 mounted() {
 let am = this;
 am.$section = am.$el;
 am.$product_cards = am.$section.querySelectorAll(".product-card");
 am.$section.removeAttribute("x-cloak");
 },
 e_SelectSize(e) {
 let am = this;
 am.selected_size = e.target.value;
 },
 }));
});

/*
document.addEventListener('rebuy:cart.change', (event) => {
 console.log('rebuy:cart.change event', event.detail);
 const widget = window?.Rebuy?.widgets?.find(w => w.id == '253066');

 if (widget) {
 widget.destroy();
 console.log('Widget has been destroyed');
 }


 setTimeout(()=>{

 Rebuy.init();
 console.log('Rebuy.init called');

 }, 1000)


});
*/

let updateCartOffersTimeout = null;

const updateCartOffers = () => {
 // Clear any pending timeout to prevent multiple rapid calls
 if (updateCartOffersTimeout) {
 clearTimeout(updateCartOffersTimeout);
 }

 const widget = window?.Rebuy?.widgets?.find((w) => w.id == "253066");
 const target = document.getElementById("cart-drawer-offers");

 if (!target) {
 console.warn("Cart drawer offers target not found");
 return;
 }

 target.innerHTML = "";

 if (widget) {
 try {
 widget.destroy();
 console.log("Widget has been destroyed");
 } catch (error) {
 console.warn("Error destroying widget:", error);
 }
 }

 updateCartOffersTimeout = setTimeout(() => {
 if (target && window.Rebuy) {
 target.insertAdjacentHTML(
 "beforeend",
 '<div data-rebuy-id="253066"></div>',
 );
 try {
 window.Rebuy.init();
 console.log("Rebuy.init called");
 } catch (error) {
 console.warn("Error initializing Rebuy:", error);
 }
 }
 updateCartOffersTimeout = null;
 }, 100); // Add 100ms delay to allow for cleanup
};

document.addEventListener("rebuy:cart.change", (event) => {
 //console.log('rebuy:cart.change -> updateCartOffers', event);
 //updateCartOffers();
});

document.addEventListener("cart:ui:updated", (event) => {
 console.log("cart:ui:updated -> updateCartOffers", event);

 updateCartOffers();

 if (window.listenForUpdate) {
 delete window.listenForUpdate;
 document.querySelector("cart-drawer-items").onCartUpdate();
 console.log("cart:ui:updated - Update listened for and refreshed!");
 }
});

(function () {
 if (window.themeSettings?.enableFinalSale === true) return;

 const SALE_PROPERTY = "Sale";
 const cartRoot = () => window.Shopify?.routes?.root || "/";

 const stripFinalSaleFromCart = async (cart) => {
 if (!cart?.items?.length) return;

 const itemsWithSale = cart.items.filter(
 (item) =>
 item.properties &&
 Object.prototype.hasOwnProperty.call(item.properties, SALE_PROPERTY),
 );
 if (!itemsWithSale.length) return;

 await Promise.all(
 itemsWithSale.map((item) => {
 const properties = { ...item.properties };
 delete properties[SALE_PROPERTY];
 return fetch(`${cartRoot()}cart/change.js`, {
 method: "POST",
 headers: { "Content-Type": "application/json" },
 body: JSON.stringify({ id: item.key, properties }),
 });
 }),
 );
 };

 const prepareCheckoutCart = async () => {
 try {
 const response = await fetch(`${cartRoot()}cart.js`);
 if (!response.ok) return;
 await stripFinalSaleFromCart(await response.json());
 } catch (_) {}
 };

 const goToCheckout = () => {
 window.location.assign(`${cartRoot()}checkout`);
 };

 document.addEventListener(
 "click",
 (event) => {
 const checkoutButton = event.target.closest(
 'button[name="checkout"], input[name="checkout"]',
 );
 if (!checkoutButton || checkoutButton.disabled) return;

 event.preventDefault();
 event.stopImmediatePropagation();
 prepareCheckoutCart().finally(goToCheckout);
 },
 true,
 );

 const patchRebuySmartCartCheckout = () => {
 const smartCart = window.Rebuy?.SmartCart;
 if (!smartCart || smartCart.__finalSaleCheckoutPatched) return;
 const originalCheckout = smartCart.checkout;
 if (typeof originalCheckout !== "function") return;

 smartCart.checkout = async function (...args) {
 await prepareCheckoutCart();
 return originalCheckout.apply(this, args);
 };
 smartCart.__finalSaleCheckoutPatched = true;
 };

 document.addEventListener("rebuy.ready", patchRebuySmartCartCheckout);
 if (window.Rebuy?.SmartCart) patchRebuySmartCartCheckout();
})();

document.addEventListener("rebuy.add", (event) => {
 console.log("rebuy.add event", event);

 // Fetch the updated cart state and render it
 const cartDrawer = document.querySelector("cart-drawer");
 if (cartDrawer) {
 let cartData;

 fetch(`${window.Shopify.routes.root}cart.js`)
 .then((response) => response.json())
 .then((cart) => {
 cartData = cart;
 // Fetch the sections needed for the cart drawer
 return fetch(
 `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble,cart-bundle-progress`,
 );
 })
 .then((response) => response.json())
 .then((sections) => {
 // Create a parsedState object similar to what the cart API returns
 const parsedState = {
 sections: sections,
 };

 // Remove is-empty class from cart-drawer element if cart was empty
 if (cartDrawer.classList.contains("is-empty")) {
 cartDrawer.classList.remove("is-empty");
 }

 // Remove is-empty class from cart-drawer-items if it exists
 const cartDrawerItems = document.querySelector("cart-drawer-items");
 if (cartDrawerItems && cartDrawerItems.classList.contains("is-empty")) {
 cartDrawerItems.classList.remove("is-empty");
 }

 // Publish cart update event through pub/sub system for theme components
 if (
 typeof publish === "function" &&
 typeof PUB_SUB_EVENTS !== "undefined"
 ) {
 publish(PUB_SUB_EVENTS.cartUpdate, {
 source: "rebuy-button",
 cartData: cartData,
 });
 }

 // Use the cart drawer's renderContents method which will:
 // 1. Update the cart UI
 // 2. Open the drawer
 // 3. Dispatch the cart:ui:updated event
 cartDrawer.renderContents(parsedState);

 console.log("Rebuy product added - cart drawer opened and updated");
 })
 .catch((error) => {
 console.error("Error updating cart after Rebuy add:", error);
 });
 }
});

/**
 * Rebuy Draggable Dots - Optimized Implementation
 * Makes Flickity carousel dots and viewport draggable/swipeable for Rebuy widgets
 */
(function () {
 "use strict";

 // Configuration constants
 const CONFIG = {
 DEFAULT_SWIPE_THRESHOLD: 30,
 DRAG_ACTIVATION_THRESHOLD: 6,
 WHEEL_COOLDOWN_MS: 140,
 INIT_DELAY_MS: 300,
 DEBOUNCE_DELAY_MS: 200,
 SELECTORS: {
 carousel:
 '#rebuy-widget-253066 .rebuy-product-grid.flickity-enabled, [id^="rebuy-widget-"] .rebuy-product-grid.flickity-enabled',
 dotsContainer: ".flickity-page-dots",
 viewport: ".flickity-viewport",
 prevButton: ".flickity-prev-next-button.previous",
 nextButton: ".flickity-prev-next-button.next",
 productCell:
 ".rebuy-product-grid [data-product-id], .rebuy-product-grid .rebuy-product-block, .rebuy-product-grid .rebuy-product",
 },
 DATA_ATTRS: {
 swipeInit: "data-rebuy-swipe-init",
 draggableInit: "data-draggable-initialized",
 carouselInit: "data-rebuy-carousel-init",
 },
 };

 // Track initialized carousels for cleanup
 const initializedCarousels = new WeakMap();

 /**
 * Utility functions
 */
 const Utils = {
 isMouseLikePointer(pointerType) {
 return pointerType === "mouse" || pointerType === "pen";
 },

 nowTime() {
 return typeof performance !== "undefined" && performance.now
 ? performance.now()
 : Date.now();
 },

 stopEvent(event) {
 if (typeof event.stopImmediatePropagation === "function") {
 event.stopImmediatePropagation();
 } else if (typeof event.stopPropagation === "function") {
 event.stopPropagation();
 }
 },

 getFlickityInstance(carousel) {
 return (
 carousel?.flickity ||
 (window.Flickity && typeof window.Flickity.data === "function"
 ? window.Flickity.data(carousel)
 : null)
 );
 },

 /**
 * Detect if wheel event is from trackpad/touchpad vs mouse wheel
 * Trackpads typically use pixel mode (deltaMode === 0) with small, precise deltas
 */
 isTrackpadWheel(event) {
 // DOM_DELTA_PIXEL (0) is typically used by trackpads
 // DOM_DELTA_LINE (1) is typically used by mouse wheels
 // DOM_DELTA_PAGE (2) is used for page scrolling
 if (event.deltaMode === 0) {
 // Pixel mode - likely trackpad, especially with small precise values
 const absDelta = Math.abs(event.deltaX);
 // Trackpads usually have smaller, more precise delta values
 return absDelta < 100 && absDelta > 0;
 }
 return false;
 },
 };

 /**
 * Threshold calculation functions
 */
 const ThresholdCalculator = {
 getSlideWidth(carousel, flickityInstance) {
 if (flickityInstance?.slides?.length) {
 const selectedSlide =
 flickityInstance.slides[flickityInstance.selectedIndex] ||
 flickityInstance.slides[0];
 if (selectedSlide?.outerWidth) {
 return selectedSlide.outerWidth;
 }
 }

 const firstCell = carousel.querySelector(CONFIG.SELECTORS.productCell);
 if (firstCell) {
 const rect = firstCell.getBoundingClientRect();
 if (rect?.width > 0) {
 return rect.width;
 }
 }

 return null;
 },

 computeDotsThreshold(dotsContainer) {
 if (!dotsContainer) {
 return CONFIG.DEFAULT_SWIPE_THRESHOLD;
 }

 const dot =
 dotsContainer.querySelector(".dot, button, li") ||
 Array.from(dotsContainer.children).find(
 (child) => child.nodeType === 1,
 );

 if (dot) {
 const rect = dot.getBoundingClientRect();
 if (rect?.width > 0) {
 let width = rect.width;
 const styles = window.getComputedStyle
 ? window.getComputedStyle(dot)
 : null;
 if (styles) {
 const marginLeft = parseFloat(styles.marginLeft) || 0;
 const marginRight = parseFloat(styles.marginRight) || 0;
 width += marginLeft + marginRight;
 }
 if (width > 4) {
 return width;
 }
 }
 }

 if (dotsContainer) {
 const containerRect = dotsContainer.getBoundingClientRect();
 const childCount = dotsContainer.children.length || 1;
 if (containerRect?.width > 0 && childCount > 0) {
 const approxWidth = containerRect.width / childCount;
 if (approxWidth > 4) {
 return approxWidth;
 }
 }
 }

 return CONFIG.DEFAULT_SWIPE_THRESHOLD;
 },

 computeViewportThreshold(carousel, viewport, flickityInstance) {
 const slideWidth = this.getSlideWidth(carousel, flickityInstance);
 if (slideWidth && slideWidth > 4) {
 return Math.max(slideWidth / 5, 30);
 }

 if (viewport) {
 const rect = viewport.getBoundingClientRect();
 if (rect?.width > 0) {
 return Math.max(rect.width / 5, 30);
 }
 }

 return 60;
 },
 };

 /**
 * Swipe navigation handler class
 */
 class SwipeNavigationHandler {
 constructor(target, carousel, computeThreshold, options = {}) {
 this.target = target;
 this.carousel = carousel;
 this.computeThreshold = computeThreshold;
 this.isViewportTarget = options.isViewportTarget || false;
 this.prevButton = options.prevButton;
 this.nextButton = options.nextButton;

 // State
 this.swipeThreshold = CONFIG.DEFAULT_SWIPE_THRESHOLD;
 this.startX = 0;
 this.startY = 0;
 this.lastTriggerX = 0;
 this.isPointerDown = false;
 this.isDragging = false;
 this.activePointerId = null;
 this.wheelRemainder = 0;
 this.lastWheelNavTs = 0;

 // Bound handlers for cleanup
 this.boundHandlers = {
 pointerdown: this.handlePointerDown.bind(this),
 pointermove: this.handlePointerMove.bind(this),
 pointerup: this.handlePointerUp.bind(this),
 pointercancel: this.handlePointerUp.bind(this),
 lostpointercapture: this.handleLostPointerCapture.bind(this),
 wheel: this.handleWheel.bind(this),
 touchstart: null,
 touchmove: null,
 touchend: null,
 touchcancel: null,
 };

 this.init();
 }

 init() {
 if (
 !this.target ||
 this.target.hasAttribute(CONFIG.DATA_ATTRS.swipeInit)
 ) {
 return;
 }

 // Add event listeners
 this.target.addEventListener(
 "pointerdown",
 this.boundHandlers.pointerdown,
 true,
 );
 this.target.addEventListener(
 "pointermove",
 this.boundHandlers.pointermove,
 true,
 );
 this.target.addEventListener(
 "pointerup",
 this.boundHandlers.pointerup,
 true,
 );
 this.target.addEventListener(
 "pointercancel",
 this.boundHandlers.pointercancel,
 true,
 );
 this.target.addEventListener(
 "lostpointercapture",
 this.boundHandlers.lostpointercapture,
 true,
 );
 this.target.addEventListener("wheel", this.boundHandlers.wheel, {
 passive: false,
 });

 // Touch fallback for older browsers
 if (!("PointerEvent" in window)) {
 this.boundHandlers.touchstart = this.createTouchWrapper(
 this.handlePointerDown.bind(this),
 );
 this.boundHandlers.touchmove = this.createTouchWrapper(
 this.handlePointerMove.bind(this),
 );
 this.boundHandlers.touchend = this.createTouchWrapper(
 this.handlePointerUp.bind(this),
 );
 this.boundHandlers.touchcancel = () => this.resetPointerState();

 this.target.addEventListener(
 "touchstart",
 this.boundHandlers.touchstart,
 { passive: false, capture: true },
 );
 this.target.addEventListener(
 "touchmove",
 this.boundHandlers.touchmove,
 { passive: false, capture: true },
 );
 this.target.addEventListener("touchend", this.boundHandlers.touchend, {
 passive: false,
 capture: true,
 });
 this.target.addEventListener(
 "touchcancel",
 this.boundHandlers.touchcancel,
 { passive: true, capture: true },
 );
 }

 // Apply styles
 this.target.style.cursor = "grab";
 this.target.style.userSelect = "none";
 this.target.style.touchAction = "pan-y";
 this.target.style.overscrollBehaviorX = "contain";

 // Mark as initialized
 this.target.setAttribute(CONFIG.DATA_ATTRS.swipeInit, "true");
 if (
 this.target ===
 this.carousel.querySelector(CONFIG.SELECTORS.dotsContainer)
 ) {
 this.target.setAttribute(CONFIG.DATA_ATTRS.draggableInit, "true");
 }
 }

 destroy() {
 if (!this.target) return;

 // Remove event listeners
 this.target.removeEventListener(
 "pointerdown",
 this.boundHandlers.pointerdown,
 true,
 );
 this.target.removeEventListener(
 "pointermove",
 this.boundHandlers.pointermove,
 true,
 );
 this.target.removeEventListener(
 "pointerup",
 this.boundHandlers.pointerup,
 true,
 );
 this.target.removeEventListener(
 "pointercancel",
 this.boundHandlers.pointercancel,
 true,
 );
 this.target.removeEventListener(
 "lostpointercapture",
 this.boundHandlers.lostpointercapture,
 true,
 );
 this.target.removeEventListener("wheel", this.boundHandlers.wheel, {
 passive: false,
 });

 if (this.boundHandlers.touchstart) {
 this.target.removeEventListener(
 "touchstart",
 this.boundHandlers.touchstart,
 { passive: false, capture: true },
 );
 this.target.removeEventListener(
 "touchmove",
 this.boundHandlers.touchmove,
 { passive: false, capture: true },
 );
 this.target.removeEventListener(
 "touchend",
 this.boundHandlers.touchend,
 { passive: false, capture: true },
 );
 this.target.removeEventListener(
 "touchcancel",
 this.boundHandlers.touchcancel,
 { passive: true, capture: true },
 );
 }

 // Reset styles
 this.target.style.cursor = "";
 this.target.style.userSelect = "";
 this.target.style.touchAction = "";
 this.target.style.overscrollBehaviorX = "";

 // Remove data attributes
 this.target.removeAttribute(CONFIG.DATA_ATTRS.swipeInit);
 this.target.removeAttribute(CONFIG.DATA_ATTRS.draggableInit);

 // Reset pointer state
 this.resetPointerState();
 }

 createTouchWrapper(handler) {
 return (e) => {
 const touch = e.touches[0] || e.changedTouches[0];
 if (!touch) return;
 handler({
 pointerId: touch.identifier,
 pointerType: "touch",
 clientX: touch.clientX,
 clientY: touch.clientY,
 buttons: 1,
 preventDefault: () => e.preventDefault(),
 });
 };
 }

 resolveThreshold() {
 if (typeof this.computeThreshold === "function") {
 const value = this.computeThreshold();
 if (typeof value === "number" && value > 4 && Number.isFinite(value)) {
 return value;
 }
 }
 return CONFIG.DEFAULT_SWIPE_THRESHOLD;
 }

 triggerNavigation(direction) {
 if (direction > 0 && this.nextButton) {
 this.nextButton.click();
 } else if (direction < 0 && this.prevButton) {
 this.prevButton.click();
 }
 }

 handlePointerDown(event) {
 const pointerType = event.pointerType || "mouse";

 // For mouse/pen, require button 1 (left click)
 if (Utils.isMouseLikePointer(pointerType) && event.buttons !== 1) {
 return;
 }

 // Allow clicks on interactive elements (buttons, links, inputs) to pass through
 const interactiveSelectors =
 'button, a, input, select, textarea, [role="button"]';
 if (event.target.closest(interactiveSelectors)) {
 return;
 }

 // Always stop event propagation and prevent default for all pointer types (mouse, touch, pen)
 Utils.stopEvent(event);
 event.preventDefault();

 this.isPointerDown = true;
 this.activePointerId = event.pointerId;
 this.startX = event.clientX;
 this.startY = event.clientY;
 this.swipeThreshold = this.resolveThreshold();
 this.lastTriggerX = this.startX;
 this.isDragging = false;

 // Set pointer capture for all pointer types (not just touch)
 if (
 this.activePointerId !== null &&
 typeof this.target.setPointerCapture === "function"
 ) {
 try {
 this.target.setPointerCapture(this.activePointerId);
 } catch (_) {
 /* no-op */
 }
 }
 }

 beginDrag(event) {
 if (!this.isPointerDown || this.isDragging) {
 return;
 }

 this.isDragging = true;
 this.lastTriggerX = this.startX;

 if (event) {
 Utils.stopEvent(event);
 event.preventDefault();
 }

 this.target.style.cursor = "grabbing";

 if (
 this.activePointerId !== null &&
 typeof this.target.setPointerCapture === "function"
 ) {
 try {
 this.target.setPointerCapture(this.activePointerId);
 } catch (_) {
 /* no-op */
 }
 }
 }

 resetPointerState(releaseCapture = true) {
 if (
 releaseCapture &&
 this.activePointerId !== null &&
 typeof this.target.releasePointerCapture === "function"
 ) {
 try {
 this.target.releasePointerCapture(this.activePointerId);
 } catch (_) {
 /* no-op */
 }
 }

 this.target.style.cursor = "grab";
 this.isPointerDown = false;
 this.isDragging = false;
 this.lastTriggerX = this.startX;
 this.activePointerId = null;
 }

 ensureDragStarted(event) {
 if (
 this.isDragging ||
 !this.isPointerDown ||
 event.pointerId !== this.activePointerId
 ) {
 return;
 }

 if (
 Utils.isMouseLikePointer(event.pointerType || "mouse") &&
 event.buttons !== 1
 ) {
 this.resetPointerState();
 return;
 }

 const deltaX = Math.abs(event.clientX - this.startX);
 const deltaY = Math.abs(event.clientY - this.startY);

 if (deltaY > deltaX && deltaY >= CONFIG.DRAG_ACTIVATION_THRESHOLD) {
 this.resetPointerState(false);
 return;
 }

 if (deltaX >= CONFIG.DRAG_ACTIVATION_THRESHOLD) {
 this.beginDrag(event);
 }
 }

 handlePointerMove(event) {
 if (!this.isPointerDown || event.pointerId !== this.activePointerId) {
 return;
 }

 if (
 Utils.isMouseLikePointer(event.pointerType || "mouse") &&
 event.buttons !== 1
 ) {
 this.resetPointerState();
 return;
 }

 this.ensureDragStarted(event);

 if (!this.isDragging) {
 return;
 }

 Utils.stopEvent(event);
 event.preventDefault();

 const currentX = event.clientX;
 if (typeof currentX !== "number") {
 return;
 }

 let diff = currentX - this.lastTriggerX;
 while (Math.abs(diff) >= this.swipeThreshold) {
 const dragDirection = diff > 0 ? 1 : -1;
 // For viewport, invert direction (opposite to drag direction)
 // For dots container, use same direction
 const navDirection = this.isViewportTarget
 ? -dragDirection
 : dragDirection;
 this.triggerNavigation(navDirection);
 this.lastTriggerX += dragDirection * this.swipeThreshold;
 diff = currentX - this.lastTriggerX;
 }
 }

 handlePointerUp(event) {
 if (event.pointerId === this.activePointerId) {
 Utils.stopEvent(event);
 event.preventDefault();
 // Treat all pointer types (mouse, touch, pen) identically
 this.resetPointerState();
 }
 }

 handleLostPointerCapture() {
 this.resetPointerState();
 }

 handleWheel(event) {
 const absX = Math.abs(event.deltaX);
 const absY = Math.abs(event.deltaY);

 if (absX <= absY) {
 return;
 }

 Utils.stopEvent(event);
 event.preventDefault();

 this.wheelRemainder += event.deltaX;
 const threshold = this.resolveThreshold();
 const now = Utils.nowTime();

 if (
 Math.abs(this.wheelRemainder) >= threshold &&
 now - this.lastWheelNavTs >= CONFIG.WHEEL_COOLDOWN_MS
 ) {
 const direction = this.wheelRemainder > 0 ? 1 : -1;

 // For viewport: trackpad moves same direction, mouse wheel moves opposite
 // For dots container: always same direction
 let navDirection = direction;
 if (this.isViewportTarget) {
 const isTrackpad = Utils.isTrackpadWheel(event);
 // Trackpad: same direction, Mouse wheel: opposite direction
 navDirection = isTrackpad ? direction : -direction;
 }

 this.triggerNavigation(navDirection);
 this.wheelRemainder -= direction * threshold;
 this.lastWheelNavTs = now;
 }
 }
 }

 /**
 * Initialize draggable dots for a single carousel
 */
 function initCarouselDraggableDots(carousel) {
 // Skip if already initialized
 if (carousel.hasAttribute(CONFIG.DATA_ATTRS.carouselInit)) {
 return;
 }

 const dotsContainer = carousel.querySelector(
 CONFIG.SELECTORS.dotsContainer,
 );
 const viewport = carousel.querySelector(CONFIG.SELECTORS.viewport);
 const prevButton = carousel.querySelector(CONFIG.SELECTORS.prevButton);
 const nextButton = carousel.querySelector(CONFIG.SELECTORS.nextButton);

 // Require navigation buttons
 if (!prevButton || !nextButton) {
 return;
 }

 const flickityInstance = Utils.getFlickityInstance(carousel);
 const handlers = [];

 // Initialize dots container swipe
 if (dotsContainer) {
 const dotsHandler = new SwipeNavigationHandler(
 dotsContainer,
 carousel,
 () => ThresholdCalculator.computeDotsThreshold(dotsContainer),
 {
 isViewportTarget: false,
 prevButton,
 nextButton,
 },
 );
 handlers.push(dotsHandler);
 }

 // Initialize viewport swipe
 if (viewport) {
 const viewportHandler = new SwipeNavigationHandler(
 viewport,
 carousel,
 () =>
 ThresholdCalculator.computeViewportThreshold(
 carousel,
 viewport,
 flickityInstance,
 ),
 {
 isViewportTarget: true,
 prevButton,
 nextButton,
 },
 );
 handlers.push(viewportHandler);
 }

 // Store handlers for cleanup
 if (handlers.length > 0) {
 initializedCarousels.set(carousel, handlers);
 carousel.setAttribute(CONFIG.DATA_ATTRS.carouselInit, "true");
 }
 }

 /**
 * Cleanup handlers for a carousel
 */
 function cleanupCarouselDraggableDots(carousel) {
 const handlers = initializedCarousels.get(carousel);
 if (handlers) {
 handlers.forEach((handler) => handler.destroy());
 initializedCarousels.delete(carousel);
 carousel.removeAttribute(CONFIG.DATA_ATTRS.carouselInit);
 }
 }

 /**
 * Main initialization function with debouncing
 */
 let initTimeout = null;
 function initRebuyDraggableDots() {
 // Clear pending timeout
 if (initTimeout) {
 clearTimeout(initTimeout);
 }

 initTimeout = setTimeout(() => {
 try {
 const rebuyCarousels = document.querySelectorAll(
 CONFIG.SELECTORS.carousel,
 );

 if (rebuyCarousels.length === 0) {
 return;
 }

 rebuyCarousels.forEach((carousel) => {
 // Huha product cards use native-style arrow navigation. Do not attach the
 // legacy Rebuy viewport/dot drag handlers to this widget.
 if (carousel.closest(".rebuy-widget--huha-card")) {
 cleanupCarouselDraggableDots(carousel);
 return;
 }
 // Cleanup if carousel was removed from DOM
 if (!document.contains(carousel)) {
 cleanupCarouselDraggableDots(carousel);
 return;
 }

 initCarouselDraggableDots(carousel);
 });
 } catch (error) {
 console.error("Error initializing Rebuy draggable dots:", error);
 } finally {
 initTimeout = null;
 }
 }, CONFIG.DEBOUNCE_DELAY_MS);
 }

 /**
 * Cleanup all initialized carousels
 */
 function cleanupAllDraggableDots() {
 try {
 const rebuyCarousels = document.querySelectorAll(
 CONFIG.SELECTORS.carousel,
 );
 rebuyCarousels.forEach(cleanupCarouselDraggableDots);
 } catch (error) {
 console.error("Error cleaning up Rebuy draggable dots:", error);
 }
 }

 /**
 * Initialize on Rebuy ready
 */
 document.addEventListener("rebuy.ready", () => {
 setTimeout(initRebuyDraggableDots, CONFIG.INIT_DELAY_MS);
 });

 /**
 * Re-initialize when cart updates (when Rebuy widget re-renders)
 */
 document.addEventListener("cart:ui:updated", () => {
 // Cleanup first to prevent memory leaks
 cleanupAllDraggableDots();
 // Then re-initialize
 setTimeout(initRebuyDraggableDots, CONFIG.INIT_DELAY_MS);
 });

 /**
 * Cleanup on page unload
 */
 window.addEventListener("beforeunload", cleanupAllDraggableDots);

 // Expose cleanup function for manual cleanup if needed
 window.RebuyDraggableDots = {
 init: initRebuyDraggableDots,
 cleanup: cleanupAllDraggableDots,
 };
})();

function refreshCollectionBundleProgress() {
  var progressEl = document.getElementById("cart-bundle-progress-collection") ||
    document.getElementById("cart-bundle-progress-collection-sticky-header");
  if (!progressEl) return;
  var sectionWrapper = progressEl.closest("[id^=\"shopify-section-\"]");
  if (!sectionWrapper) return;
  var sectionId = sectionWrapper.id.replace(/^shopify-section-/, "");
  var url = window.location.pathname + "?sections=" + encodeURIComponent(sectionId) +
    "&sections_url=" + encodeURIComponent(window.location.pathname);
  fetch(url)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var html = data[sectionId];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var newBanner = doc.querySelector("#cart-bundle-progress-collection");
      var oldBanner = document.querySelector("#cart-bundle-progress-collection");
      if (newBanner && oldBanner) oldBanner.innerHTML = newBanner.innerHTML;
      var newSticky = doc.querySelector(".cart-bundle-progress-sticky-header__inner");
      var oldSticky = document.querySelector(".cart-bundle-progress-sticky-header__inner");
      if (newSticky && oldSticky) oldSticky.innerHTML = newSticky.innerHTML;
    })
    .catch(function () {});
}

window.setProductBundleProgressContent = function (progressEl, newInnerHTML) {
  if (!progressEl || !newInnerHTML) return;
  var wrap = document.createElement("div");
  wrap.innerHTML = newInnerHTML;
  wrap.setAttribute("aria-hidden", "true");
  wrap.style.cssText = "position:absolute;left:0;right:0;top:0;visibility:hidden;pointer-events:none;";
  if (getComputedStyle(progressEl).position === "static") progressEl.style.position = "relative";
  progressEl.appendChild(wrap);
  var h = progressEl.offsetHeight + "px";
  progressEl.style.minHeight = h;
  while (progressEl.firstChild !== wrap) progressEl.removeChild(progressEl.firstChild);
  wrap.style.cssText = "";
  wrap.removeAttribute("aria-hidden");
  while (wrap.firstChild) progressEl.appendChild(wrap.firstChild);
  progressEl.removeChild(wrap);
  requestAnimationFrame(function () { progressEl.style.minHeight = ""; });
};

function refreshProductBundleProgress() {
  var progressEl = document.getElementById("cart-bundle-progress");
  if (!progressEl) return;
  var sectionWrapper = progressEl.closest("[id^=\"shopify-section-\"]");
  if (!sectionWrapper) return;
  var sectionId = sectionWrapper.id.replace(/^shopify-section-/, "");
  var url = window.location.pathname + "?sections=" + encodeURIComponent(sectionId) +
    "&sections_url=" + encodeURIComponent(window.location.pathname);
  fetch(url)
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var html = data[sectionId];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, "text/html");
      var newProgress = doc.querySelector("#cart-bundle-progress");
      if (newProgress) window.setProductBundleProgressContent(progressEl, newProgress.innerHTML);
    })
    .catch(function () {});
}

document.addEventListener("cart:ui:updated", function () {
  refreshCollectionBundleProgress();
  refreshProductBundleProgress();
});

// Rebuy Widget Accordion for Cart Cross-sells
(function () {
 const STORAGE_KEY = "rebuyAccordionState";

 function initRebuyAccordion() {
 const widget = document.querySelector("#rebuy-widget-253066");
 if (!widget) return;

 const primaryTitle = widget.querySelector(".primary-title");
 const productGrid = widget.querySelector(".rebuy-product-grid");

 if (!primaryTitle || !productGrid) return;

 // Check if already initialized
 if (primaryTitle.querySelector(".rebuy-accordion-arrow")) return;

 // Make title clickable and add arrow
 primaryTitle.style.cursor = "pointer";
 primaryTitle.style.display = "flex";
 primaryTitle.style.justifyContent = "space-between";
 primaryTitle.style.alignItems = "center";
 primaryTitle.style.userSelect = "none";

 // Create arrow icon
 const arrow = document.createElement("span");
 arrow.className = "rebuy-accordion-arrow";
 arrow.innerHTML =
 '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg>';
 arrow.style.transition = "transform 0.3s ease";
 primaryTitle.appendChild(arrow);

 // Restore saved state or default to open
 const savedState = localStorage.getItem(STORAGE_KEY);
 const isOpen = savedState !== null ? savedState === "true" : true;

 primaryTitle.dataset.open = isOpen.toString();

 if (isOpen) {
 productGrid.style.display = "block";
 arrow.style.transform = "rotate(180deg)"; // Point down

 // Trigger Flickity resize
 triggerFlickityResize(productGrid);
 } else {
 productGrid.style.display = "none";
 arrow.style.transform = "rotate(0deg)"; // Point up
 }

 // Mark widget as initialized to prevent flash
 widget.classList.add("rebuy-initialized");

 // Function to trigger Flickity resize
 function triggerFlickityResize(grid) {
 if (!grid) return;

 // Wait for display change to take effect
 requestAnimationFrame(() => {
 // Force a reflow to ensure dimensions are calculated
 void grid.offsetHeight;

 // Try to get and resize Flickity instance
 if (grid.classList.contains("flickity-enabled")) {
 const flickityInstance =
 window.Flickity && window.Flickity.data(grid);

 if (flickityInstance) {
 // Flickity resize method
 if (typeof flickityInstance.resize === "function") {
 flickityInstance.resize();
 }
 // Also try reloadCells in case resize doesn't work
 if (typeof flickityInstance.reloadCells === "function") {
 flickityInstance.reloadCells();
 }
 }
 }

 // Additional fallback: trigger viewport height recalculation
 const viewport = grid.querySelector(".flickity-viewport");
 if (viewport && viewport.style.height === "0px") {
 viewport.style.height = "";
 // Force Flickity to recalculate by dispatching a resize event
 setTimeout(() => {
 window.dispatchEvent(new Event("resize"));
 }, 50);
 }
 });
 }

 // Toggle function
 primaryTitle.addEventListener("click", function () {
 const isOpen = this.dataset.open === "true";

 if (isOpen) {
 // Close
 productGrid.style.display = "none";
 arrow.style.transform = "rotate(0deg)"; // Point up
 this.dataset.open = "false";
 localStorage.setItem(STORAGE_KEY, "false");
 } else {
 // Open
 productGrid.style.display = "block";
 arrow.style.transform = "rotate(180deg)"; // Point down
 this.dataset.open = "true";
 localStorage.setItem(STORAGE_KEY, "true");

 // Trigger Flickity resize
 triggerFlickityResize(productGrid);
 }
 });
 }

 // Initialize on page load
 if (document.readyState === "loading") {
 document.addEventListener("DOMContentLoaded", initRebuyAccordion);
 } else {
 initRebuyAccordion();
 }

 // Re-initialize when cart drawer opens/updates
 document.addEventListener("cart:updated", initRebuyAccordion);
 document.addEventListener("cart:ui:updated", initRebuyAccordion);

 // Watch for Rebuy widget mutations (when it loads dynamically)
 const observer = new MutationObserver(function (mutations) {
 mutations.forEach(function (mutation) {
 if (mutation.addedNodes.length) {
 const rebuyWidget = document.querySelector("#rebuy-widget-253066");
 if (
 rebuyWidget &&
 !rebuyWidget.querySelector(".rebuy-accordion-arrow")
 ) {
 initRebuyAccordion();
 }
 }
 });
 });

 observer.observe(document.body, {
 childList: true,
 subtree: true,
 });
})();

// ---------------------------------------------------------------------------
// BIS Waitlist -- PDP modal + PLP click handler
// ---------------------------------------------------------------------------

function initBisWaitlist(sectionId) {
  var config = window.bisWaitlistConfig?.[sectionId];
  if (!config) return;

  window.HuHaBis = window.HuHaBis || { refresh: {} };

  var sectionWrapper = document.getElementById('shopify-section-' + sectionId);
  if (!sectionWrapper) return;

  var waitlistBtn = sectionWrapper.querySelector('[data-bis-waitlist-trigger]');
  var modal = sectionWrapper.querySelector('[data-bis-waitlist-modal]');
  if (!waitlistBtn || !modal) return;

  document.body.appendChild(modal);

  function isSelectionIncompleteForBis() {
    var vr = document.querySelector(
      'variant-radios[data-section="' + sectionId + '"]'
    );
    if (!vr || vr.dataset.requireSizeSelection !== 'true') return false;
    return vr.dataset.variantOptionsComplete !== 'true';
  }

  function updateButtonVisibility() {
    var variantInput = document.querySelector(
      '#product-form-' + sectionId + ' .product-variant-id'
    );
    if (variantInput) waitlistBtn.dataset.variantId = variantInput.value;

    var addButton = document.getElementById('ProductSubmitButton-' + sectionId);
    if (!addButton) return;
    var buttonContainer = waitlistBtn.closest('.product-form__buttons');

    function setBisActiveState(isActive) {
      if (!buttonContainer) return;
      buttonContainer.classList.toggle('bis-waitlist-active', isActive);
    }

    var addButtonText = addButton.querySelector('.add-to-cart-text');
    var textContent = (addButtonText?.textContent || '').trim();
    var soldOutText = window.variantStrings?.soldOut || 'Sold out';

    var bisPendingPrimary =
      waitlistBtn.getAttribute('data-bis-pending-primary') === 'true';
    var incomplete = isSelectionIncompleteForBis();

    if (bisPendingPrimary && incomplete) {
      waitlistBtn.style.display = '';
      waitlistBtn.disabled = true;
      setBisActiveState(true);
      var pend =
        waitlistBtn.dataset.pendingSizeLabel ||
        (window.variantStrings && window.variantStrings.selectSize) ||
        '';
      waitlistBtn.textContent = pend;
      waitlistBtn.classList.add('bis-waitlist-btn--pending-size');
      return;
    }

    if (bisPendingPrimary && !incomplete) {
      waitlistBtn.removeAttribute('data-bis-pending-primary');
      waitlistBtn.disabled = false;
      waitlistBtn.classList.remove('bis-waitlist-btn--pending-size');
      waitlistBtn.style.backgroundColor = '';
      waitlistBtn.style.color = '';
      var defLabel = waitlistBtn.dataset.bisDefaultLabel;
      if (defLabel) waitlistBtn.textContent = defLabel;
    }

    var isSoldOut =
      (addButton.hasAttribute('disabled') ||
        addButton.getAttribute('aria-disabled') === 'true') &&
      textContent === soldOutText;

    waitlistBtn.style.display = isSoldOut ? '' : 'none';
    setBisActiveState(isSoldOut);
  }

  window.HuHaBis.refresh[sectionId] = updateButtonVisibility;

  updateButtonVisibility();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
      if (event.data?.sectionId !== sectionId) return;
      updateButtonVisibility();
    });
  }

  var modalContent = modal.querySelector('.bis-waitlist-modal__content');
  var trapRetryTimeout = null;
  var stoqRetryInterval = null;

  function trapModalFocus() {
    if (typeof trapFocus === 'function') {
      trapFocus(modalContent, modal.querySelector('.bis-waitlist-modal__close'));
    }
  }



  var successInterval = null;

  function watchForSuccess() {
    if (!config.successMessage && !config.successHeading) return;
    if (successInterval) clearInterval(successInterval);
    successInterval = setInterval(function() {
      var successText = document.querySelector('#form-Success-Text');
      if (successText) {
        if (config.successMessage) successText.textContent = config.successMessage;
        if (config.successHeading) {
          var heading = modal.querySelector('.bis-waitlist-modal__heading');
          if (heading) heading.textContent = config.successHeading;
        }
        clearInterval(successInterval);
        successInterval = null;
      }
    }, 200);
  }

  function openModal() {
    if (waitlistBtn.disabled) return;
    var variantId = waitlistBtn.dataset.variantId;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    if (trapRetryTimeout) clearTimeout(trapRetryTimeout);
    if (stoqRetryInterval) { clearInterval(stoqRetryInterval); stoqRetryInterval = null; }

    var containerSelector = '[data-bis-inline-form="' + sectionId + '"]';
    var container = modal.querySelector('[data-bis-inline-form]');

    if (container && window._RestockRocket) {
      container.innerHTML = '';
      window._RestockRocket.openInlineForm(
        config.productData,
        String(variantId),
        null,
        containerSelector,
        'beforeend'
      );
      watchForSuccess();
      trapModalFocus();
      trapRetryTimeout = setTimeout(trapModalFocus, 500);
    } else if (container && !window._RestockRocket) {
      container.innerHTML = '<p style="text-align:center;padding:2rem 0;">Loading...</p>';
      trapModalFocus();
      var attempts = 0;
      stoqRetryInterval = setInterval(function() {
        attempts++;
        if (window._RestockRocket) {
          clearInterval(stoqRetryInterval);
          stoqRetryInterval = null;
          container.innerHTML = '';
          window._RestockRocket.openInlineForm(
            config.productData,
            String(variantId),
            null,
            containerSelector,
            'beforeend'
          );
          watchForSuccess();
          trapModalFocus();
          trapRetryTimeout = setTimeout(trapModalFocus, 500);
        } else if (attempts > 10) {
          clearInterval(stoqRetryInterval);
          stoqRetryInterval = null;
          container.innerHTML = '<p style="text-align:center;padding:2rem 0;">Unable to load form. Please refresh and try again.</p>';
        }
      }, 500);
    }
  }

  function closeModal() {
    if (trapRetryTimeout) { clearTimeout(trapRetryTimeout); trapRetryTimeout = null; }
    if (stoqRetryInterval) { clearInterval(stoqRetryInterval); stoqRetryInterval = null; }
    if (successInterval) { clearInterval(successInterval); successInterval = null; }
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(waitlistBtn);
    }
    if (window._RestockRocket) {
      window._RestockRocket.removeInlineForm();
    }
  }

  waitlistBtn.addEventListener('click', openModal);

  modal.querySelectorAll('[data-bis-modal-close]').forEach(function(el) {
    el.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', function(e) {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
      closeModal();
    }
  });
}

// PLP waitlist: no modal – buttons link straight to PDP (see card-product.liquid btn-waitlist <a href>)
// document.addEventListener('click', function(e) {
//   var trigger = e.target.closest('[data-bis-plp-trigger]');
//   if (!trigger) return;
//   e.preventDefault();
//
//   var productId = parseInt(trigger.dataset.productId, 10);
//   var variantId = trigger.dataset.variantId;
//   var productData = { id: productId, variants: [{ id: parseInt(variantId, 10), available: false }] };
//
//   if (window._RestockRocket) {
//     window._RestockRocket.openModal(productData, variantId);
//   } else {
//     if (trigger.classList.contains('loading')) return;
//     trigger.classList.add('loading');
//     var attempts = 0;
//     var retry = setInterval(function() {
//       attempts++;
//       if (window._RestockRocket) {
//         clearInterval(retry);
//         trigger.classList.remove('loading');
//         window._RestockRocket.openModal(productData, variantId);
//       } else if (attempts > 10) {
//         clearInterval(retry);
//         trigger.classList.remove('loading');
//         window.location.href = trigger.closest('.card-wrapper')?.querySelector('a')?.href || '/';
//       }
//     }, 300);
//   }
// });

// Initialize PDP waitlist on page load
(function() {
  var configs = window.bisWaitlistConfig;
  if (!configs) return;
  Object.keys(configs).forEach(function(sectionId) {
    initBisWaitlist(sectionId);
  });
})();

// Re-initialize when sections are re-rendered in the theme editor
document.addEventListener('shopify:section:load', function(event) {
  var sectionId = event.target.id.replace('shopify-section-', '');
  if (window.bisWaitlistConfig?.[sectionId]) {
    initBisWaitlist(sectionId);
  }
});

// Rewards page: hide "Never" points expiry values in the Yotpo popup table.
(function() {
  var rewardsTemplateClass = 'template-page-rewards-2';
  var isInitialized = false;

  function isRewardsTemplate() {
    if (!document.body) return false;
    return document.body.classList.contains(rewardsTemplateClass);
  }

  function hideNeverPointsExpiry() {
    var expiryElements = document.querySelectorAll(
      '.yotpo-loyalty-popup-overlay .third-row-desktop .row-expiration-column .yotpo-inner-text'
    );

    expiryElements.forEach(function(expiryElement) {
      var expiryText = (expiryElement.textContent || '').trim().toLowerCase();
      if (expiryText !== 'never') return;

      var expirationColumn = expiryElement.closest('.row-expiration-column');
      if (!expirationColumn) return;

      expirationColumn.style.display = 'none';
      expirationColumn.setAttribute('hidden', '');
      expirationColumn.setAttribute('aria-hidden', 'true');
    });
  }

  function initRewardsNeverExpiry() {
    if (!isRewardsTemplate() || isInitialized) return;
    isInitialized = true;

    hideNeverPointsExpiry();

    var rewardsPopupObserver = new MutationObserver(function() {
      hideNeverPointsExpiry();
    });

    rewardsPopupObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRewardsNeverExpiry);
  } else {
    initRewardsNeverExpiry();
  }
})();